import AppointmentsWithDocuments from "../../../components/appointmentsWithDocuements/AppointmentsWithDocuments";
import FilterAppointmentsWithDocuments from "../../../contexts/FilterAppointmentsWithDocuments";

export default function PetDocumentsTab() {
  return (
    <FilterAppointmentsWithDocuments>
      <AppointmentsWithDocuments />
    </FilterAppointmentsWithDocuments>
  );
}
